'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _util = require('./util');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var Tip = (_temp = _class = function (_Component) {
  _inherits(Tip, _Component);

  function Tip() {
    _classCallCheck(this, Tip);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  Tip.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    this.handle = this.props.handle;
    this.willDetach = this.handle.onTipChange(function () {
      return _this2.forceUpdate();
    });
  };

  Tip.prototype.componentDidMount = function componentDidMount() {
    this.updateTip();
  };

  Tip.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
    return false;
  };

  Tip.prototype.componentDidUpdate = function componentDidUpdate() {
    this.updateTip();
  };

  Tip.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.willDetach) {
      this.willDetach();
    }
    this.clearTimer();
  };

  Tip.prototype.clearTimer = function clearTimer() {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
  };

  Tip.prototype.updateTip = function updateTip() {
    var popup = this.shell;
    var arrow = popup.querySelector('.ve-arrow');

    // reset
    popup.className = this.originClassName;
    popup.style.cssText = '';
    arrow.style.cssText = '';
    this.clearTimer();

    var tip = this.handle.getTip();
    if (!tip) {
      return;
    }

    var target = tip.target,
        position = tip.position;

    var targetRect = target.getBoundingClientRect();

    if (targetRect.width === 0 || targetRect.height === 0) {
      return;
    }

    var popupRect = popup.getBoundingClientRect();
    var bounds = {
      left: 1,
      top: 1,
      right: document.documentElement.clientWidth - 1,
      bottom: document.documentElement.clientHeight - 1
    };

    var arrowRect = arrow.getBoundingClientRect();

    var _resolvePosition = (0, _util.resolvePosition)(popupRect, targetRect, arrowRect, bounds, position),
        dir = _resolvePosition.dir,
        left = _resolvePosition.left,
        top = _resolvePosition.top,
        arrowLeft = _resolvePosition.arrowLeft,
        arrowTop = _resolvePosition.arrowTop;

    popup.classList.add('ve-align-' + dir);
    popup.style.top = top + 'px';
    popup.style.left = left + 'px';
    popup.style.width = popupRect.width + 'px';
    popup.style.height = popupRect.height + 'px';

    if (dir === 'top' || dir === 'bottom') {
      popup.style.transform = 'translateY(' + (dir === 'top' ? 5 : -5) + 'px)';
      arrow.style.left = arrowLeft + 'px';
    } else {
      popup.style.transform = 'translateX(' + (dir === 'left' ? 5 : -5) + 'px)';
      arrow.style.top = arrowTop + 'px';
    }
    this.timer = setTimeout(function () {
      popup.classList.add('ve-visible-animate');
      popup.style.transform = 'none';
    }, 10);
  };

  Tip.prototype.render = function render() {
    var _this3 = this;

    var tip = this.handle.getTip();
    var className = (0, _classnames2.default)('ve-tip', tip && tip.theme ? 've-theme-' + tip.theme : null);
    var content = tip ? tip.content : null;
    var innerHTML = null;

    if (typeof content === 'string') {
      innerHTML = { __html: content };
      content = null;
    }

    this.originClassName = className;

    return _react2.default.createElement(
      'div',
      { className: className, ref: function ref(_ref) {
          _this3.shell = _ref;
        } },
      _react2.default.createElement('i', { className: 've-arrow' }),
      _react2.default.createElement(
        'div',
        {
          className: 've-tip-content',
          dangerouslySetInnerHTML: innerHTML
        },
        content
      )
    );
  };

  return Tip;
}(_react.Component), _class.propTypes = {
  handle: _react.PropTypes.object.isRequired
}, _temp);
exports.default = Tip;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/_@ali_ve-popups@4.2.3@@ali/ve-popups/build/tip.js
// module id = 289
// module chunks = 0